import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { TABLET_P } from '@/constants';
import { generateKey } from '@/utils';
import Placeholder from '@/components/Placeholder';
import Markdown from '@/components/Markdown';
import {
  Wrapper,
  ProfileList,
  CompanyOverview,
  TitleBorder,
  ContactLinker,
  PlaceholderWrapper,
  MarkdownStyle,
  CompanyProfileList,
  CompanyProfileTerm,
  CompanyProfileDescription,
} from '@/pages/AboutPage/CompanySection.style';

const CompanySection = ({ data, locale }) => {
  // Placeholder 表示に使用する
  const placeholderStart = 1;
  const placeholderEnd = 9;

  const companyOverview = _.find(data.companyProfile, item => _.get(item, 'companyprofilelongtext'));
  const companyProfile = _.find(data.companyProfile, item => _.get(item, 'contents'));

  return (
    <Wrapper id="company-section">
      {/* 「会社概要」見出し */}
      <CompanyOverview>
        {(!!(companyOverview && _.get(companyOverview, 'title')) && companyOverview.title) || (
          <Placeholder w="70px" h="20px" />
        )}
      </CompanyOverview>
      <TitleBorder bottom="60px" />
      {/* 会社名、概要リンク表示部分 */}
      {!(companyOverview && _.get(companyOverview, 'companyprofilelongtext')) ? (
        <PlaceholderWrapper>
          <Placeholder w="300px" h="20px" m="0 0 120px 0" />
        </PlaceholderWrapper>
      ) : (
        <Markdown Component={MarkdownStyle} src={companyOverview.companyprofilelongtext} />
      )}
      {/* 「関連会社概要」見出し */}
      {!(companyProfile && _.get(companyProfile, 'title')) ? (
        <PlaceholderWrapper>
          <Placeholder w="70px" h="20px" m="0 0 10px 0" />
        </PlaceholderWrapper>
      ) : (
        <CompanyOverview>{companyProfile.title}</CompanyOverview>
      )}
      <TitleBorder bottom="80px" />
      {/* 関連会社概要 内容 */}
      <ProfileList>
        {!companyProfile && (
          <React.Fragment>
            {new Array(placeholderEnd - placeholderStart).fill(null).map((item, index) => (
              <CompanyProfileList direction="column" key={generateKey('placeholder', index)}>
                <Placeholder w="100%" h="24px" />
              </CompanyProfileList>
            ))}
          </React.Fragment>
        )}
        {companyProfile && (
          <React.Fragment>
            {companyProfile.contents.map((item, index) => (
              <CompanyProfileList
                key={generateKey('company-profile', index)}
                direction={window.innerWidth > TABLET_P ? 'row' : 'column'}
              >
                <CompanyProfileTerm>{item.title}</CompanyProfileTerm>
                <CompanyProfileDescription>{item.content}</CompanyProfileDescription>
              </CompanyProfileList>
            ))}
          </React.Fragment>
        )}
      </ProfileList>
      {/* お問い合わせ */}
      <ContactLinker>
        {!(companyProfile && _.get(companyProfile, 'linkLabel')) ? (
          <Placeholder w="70px" h="20px" m="0 0 10px 0" />
        ) : (
          <Link to={`/${locale}/contact-us`} href={`/${locale}/contact-us`}>
            {companyProfile.linkLabel}
          </Link>
        )}
      </ContactLinker>
    </Wrapper>
  );
};

CompanySection.propTypes = {
  data: PropTypes.shape({}).isRequired,
  locale: PropTypes.string.isRequired,
};

export default CompanySection;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/CompanySection.js